import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import CollapsibleRow from '../CollapsibleRow/index';
import CircularProgress from '@material-ui/core/CircularProgress';
import styles from './index.css';
import {FormattedMessage} from 'react-intl';


function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}


const headCells = [
    {id: 'bundleNumber', numeric: false, disablePadding: false, label: <FormattedMessage id={'labels.BUNDLE'}/>},
    {id: 'quoteNumber', numeric: false, disablePadding: false, label: <FormattedMessage id={'labels.QUOTE'}/>},
    {id: 'startDate', numeric: false, disablePadding: false, label: <FormattedMessage id={'labels.START_DATE'}/>},
    {id: 'alfaDealerName', numeric: false, disablePadding: false, label: <FormattedMessage id={'labels.DEALERSHIP_NAME'}/>},
    {id: 'primaryCustomer', numeric: false, disablePadding: false, label: <FormattedMessage id={'labels.PRIMARY_CUSTOMER'}/>},
    {id: 'salesPersonName', numeric: false, disablePadding: false, label: <FormattedMessage id={'labels.SALESPERSON'}/>}
]

function EnhancedTableHead(props) {
    const {classes, order, orderBy, onRequestSort} = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell/>
                {headCells.map((headCell) => (
                    <TableCell
                        align={headCell.numeric ? 'right' : 'left'}
                        key={headCell.id}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        style={{'fontWeight': 'bold'}}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
                <TableCell style={{'fontWeight': 'bold'}}>
                    <FormattedMessage id={'labels.ACTION'}/>
                </TableCell>
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%'
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2)
    },
    table: {
        minWidth: 750
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    }
}));


export default function EnhancedTable({handleGetStatus, rows, userBranchCode, userHasAccessToERegistry}) {
    const classes = useStyles();
    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('createdDate');

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                {rows.length > 0 ? <TableContainer component={Paper}>
                    <Table aria-label="collapsible table">
                        <EnhancedTableHead
                            classes={classes}
                            onRequestSort={handleRequestSort}
                            order={order}
                            orderBy={orderBy}
                            rowCount={rows.length}
                        />
                        <TableBody>
                            {stableSort(rows, getComparator(order, orderBy))
                                .map((row) => {
                                    return (
                                        <CollapsibleRow
                                            handleGetStatus={handleGetStatus}
                                            key={row.quoteNumber}
                                            row={row}
                                            userBranchCode={userBranchCode}
                                            userHasAccessToERegistry={userHasAccessToERegistry}
                                        />
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer> :
                    (<CircularProgress
                        className={`${styles.tableProgress}`}
                        disableShrink
                        size={50}
                        thickness={5}
                    />)
                }
            </Paper>
        </div>
    );
}
EnhancedTable.propTypes = {
    handleGetStatus: PropTypes.func.isRequired,
    rows: PropTypes.array,
    userBranchCode: PropTypes.string.isRequired,
    userHasAccessToERegistry: PropTypes.bool.isRequired
};
